<template>
  <div>
    <DynamicForm
      form="student_information_form"
      title="Student Information"
      :initialData="student"
      :handleSubmit="handleSubmit"
    ></DynamicForm>
  </div>
</template>

<script>
import DynamicForm from "@/components/forms/DynamicForm.component.vue";
import studentsService from "@/services/students-service";
export default {
  components: { DynamicForm },
  data() {
    return {
      studentsList: [],
      studentId: null,
      student: {},
    };
  },
  mounted() {
    this.getCrmStudentsList();
  },
  watch: {
    studentId() {
      this.getCrmStudentData();
    },
  },
  methods: {
    getCrmStudentData() {
      studentsService.getCrmStudentData(this.studentId).then((response) => {
        this.student = response.data;
      });
    },
    getCrmStudentsList() {
      studentsService.getCrmStudentsList().then((response) => {
        this.studentsList = response.data.sort((a, b) =>
          a.grade_score > b.grade_score ? 1 : -1
        );
        this.studentId =
          this.studentsList.length > 0 ? this.studentsList[0].id : null;
      });
    },
    handleSubmit(payload) {
      studentsService
        .updateStudent(this.studentId, payload)
        .then((response) => {
          this.student = response.data;
        });
    },
  },
};
</script>
